import React, { FC } from 'react';
import classNames from 'classnames';
import { Stage } from './enums/stage.enum';
import { StageCardStageProps } from './props';
import './styles.scss';

const STATUS_BY_STAGE: Record<Stage, string> = {
  [Stage.IS_COLLECTING_OFFERS]: 'Collecting offers',
  [Stage.IS_IN_CONVERSATION]: 'In conversation',
  [Stage.IS_OFF_THE_MARKET]: 'Off the market',
};

export const StageCardStage: FC<StageCardStageProps> = ({ stage }) => {
  return (
    <div className="stage-card-stage">
      <div className="stage-card-stage__title-wrapper">
        <div className="stage-card-stage__title">Stage</div>
        <div className="stage-card-stage__status">{STATUS_BY_STAGE[stage]}</div>
      </div>
      <div className="stage-card-stage__steps-wrapper">
        <div
          className={classNames({
            'pulse-fade': [Stage.IS_COLLECTING_OFFERS, Stage.IS_IN_CONVERSATION].includes(stage),
            'stage-card-stage__step': true,
            'stage-card-stage__step--first': true,
            'stage-card-stage__step--green': stage === Stage.IS_COLLECTING_OFFERS,
            'stage-card-stage__step--red': stage === Stage.IS_OFF_THE_MARKET,
            'stage-card-stage__step--yellow': stage === Stage.IS_IN_CONVERSATION,
          })}
        />
        <div
          className={classNames({
            'pulse-fade': stage === Stage.IS_IN_CONVERSATION,
            'stage-card-stage__step': true,
            'stage-card-stage__step--red': stage === Stage.IS_OFF_THE_MARKET,
            'stage-card-stage__step--yellow': stage === Stage.IS_IN_CONVERSATION,
          })}
        />
        <div
          className={classNames({
            'stage-card-stage__step': true,
            'stage-card-stage__step--last': true,
            'stage-card-stage__step--red': stage === Stage.IS_OFF_THE_MARKET,
          })}
        />
      </div>
    </div>
  );
};
